// components/ThumbButtons.tsx
import React from "react";
import thumbsUp from "@assets/thumbs_up.svg";
import thumbsUpSelected from "@assets/thumbs_up_selected.svg";
import thumbsDown from "@assets/thumbs_down.svg";
import thumbsDownSelected from "@assets/thumbs_down_selected.svg";

interface Props {
  index: number;
  selectedThumbs: { [key: number]: "like" | "dislike" | null };
  feedbackSubmittedFor: { [key: number]: string };
  handleThumbClick: (index: number, type: "like" | "dislike") => void;
  feedbackSubmitted?: boolean;
  feedbackUpdating: boolean;
  alignment?: string;
}

const ThumbButtons: React.FC<Props> = ({
  index,
  selectedThumbs,
  feedbackSubmittedFor,
  handleThumbClick,
  feedbackSubmitted = false,
  feedbackUpdating = false,
  alignment = "justify-start",
}) => {
  const buttonsDisabled =
    Boolean(feedbackSubmittedFor[index]) ||
    feedbackSubmitted ||
    feedbackUpdating;

  return (
    <div className={`flex gap-2 mt-4 text-sm text-gray-500 ${alignment}`}>
      <button
        onClick={() => handleThumbClick(index, "like")}
        disabled={buttonsDisabled}
        className={`${buttonsDisabled ? "cursor-not-allowed opacity-50" : ""}`}
      >
        <img
          src={selectedThumbs[index] === "like" ? thumbsUpSelected : thumbsUp}
          alt="Thumbs Up"
          className="w-5 h-5"
        />
      </button>
      <button
        onClick={() => handleThumbClick(index, "dislike")}
        disabled={buttonsDisabled}
        className={`${buttonsDisabled ? "cursor-not-allowed opacity-50" : ""}`}
      >
        <img
          src={
            selectedThumbs[index] === "dislike"
              ? thumbsDownSelected
              : thumbsDown
          }
          alt="Thumbs Down"
          className="w-5 h-5"
        />
      </button>
    </div>
  );
};

export default ThumbButtons;
